import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../_services/Authentication.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Globals} from '../../../_globals/globals';

import { Store, select } from '@ngrx/store';
import * as fromUser from '../../../user/state/user.reducer';
import * as userActions from '../../../user/state/user.actions';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { User } from '../../../_models/user';
import * as rootActions from '../../../state/app.actions';
import * as fromRoot from '../../../state/app.reducer';
import { Translation } from '../../../_languages/translations';

@Component({
  templateUrl: './user-shell.component.html'
})

export class UserShellComponent implements OnInit {

  returnUrl: string;
  accessBlocked: boolean;
  accessBlockedMessage: string;
  sessionExpired: boolean;
  loginError: string;

  // errorMessage$: Observable<string>;
  currentUser$: Observable<User>;

constructor(
    private authenticationService: AuthenticationService,
    private globals: Globals,
    private storeRoot: Store<fromRoot.State>,
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<fromUser.State>,
    public trans: Translation
  ) { }

  ngOnInit() {

    // reset login status
    this.authenticationService.logout();

    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/main';
    this.accessBlocked = this.route.snapshot.queryParams.reason === 'access_blocked';
    this.sessionExpired = this.route.snapshot.queryParams.reason === 'session_expired';
    this.accessBlockedMessage = this.accessBlocked
      ? sessionStorage.getItem('dimpro_access_block_message') || 'Tu acceso ha sido bloqueado. Contacta con soporte.'
      : '';
    sessionStorage.removeItem('dimpro_access_block_message');
    this.loginError = '';

    // ----------- STORE -----------

    // this.store.pipe(select(fromUser.getCurrentUser),
    // takeWhile(() => this.componentActive))
    //   .subscribe( currentUsers => {
    //         console.log(' >>>> Modificado store currentUsers: ');
    //         console.log(currentUsers);
    //         this.demoCurrentUser = currentUsers;
    //       }
    // );

    this.currentUser$ = this.store.pipe(select(fromUser.getCurrentUser)) as Observable<User>;
  }

//   ngOnDestroy() {
//     console.log("--> --> Destruyendo componente login...");

//     this.subscriptionUserId.unsubscribe();
//     this.subscriptionUserName.unsubscribe();
//     this.subscriptionUserRole.unsubscribe();
//     this.subscriptionUserEnviroment.unsubscribe();
//     this.subscriptionCurrentUsers.unsubscribe();

//     this.componentActive = false;
//   }

  logIn(loginParam: {
      email: string,
      password: string
    }): void {

    console.log('---> UserShellComponent logIn -> loginParam: ');
    // console.log(loginParam);

    this.authenticationService.login(loginParam.email, loginParam.password)
      .pipe(first())
      .subscribe(
        data => {
          this.loginError = '';
          console.log('->> Resultado autenticación:');
          // console.log(data);

          this.currentUser$ = this.store.pipe(select(fromUser.getCurrentUser)) as Observable<User>;

          this.router.navigate([this.returnUrl]);
          this.globals.currentUserName = data.name; //localStorage.getItem('name') + '@';
          this.globals.currentUserRole = data.role; //localStorage.getItem('role');
          this.globals.currentUserEnviroment = data.enviroment; //localStorage.getItem('enviroment');
          this.globals.currentUserLanguage = data.lang; //localStorage.getItem('lang');
          this.globals.currentUserEmail = data.email; //localStorage.getItem('email');
          this.globals.currentUserUsername = data.username; //localStorage.getItem('username');
          this.globals.currentUserGroup = data.group_id.toString(); //localStorage.getItem('user_group');
          this.globals.currentUserPermissions = data.permissions.toString(); //localStorage.getItem('permissions');

          // IMPORTANTE: Asignamos el idioma del usuario logueado para mostrar sus correspondientes traducciones.
          this.trans.changeLanguage(data.lang);

          // Store actions
          if (data.user_id !== undefined && data.user_id != null && data.user_id >= 0) {
            this.store.dispatch(new userActions.SetCurrentUser(data));
          } else {
              this.store.dispatch(new userActions.ClearUser());
          }

        },
        error => {
            console.error('--> ... ERROR al loguear al usuario: ');
            console.error(error);

            // Guardamos el error
            // this.errorMessage$ = error;
            this.loginError = typeof error === 'string' && error
              ? error
              : 'No se ha podido iniciar sesión.';
            this.storeRoot.dispatch( new rootActions.ChangeAlertModal({value: true, info: this.loginError}));

            // Se detiene el "temporizador de carga".
            //this.loading = false;
        });
  }

} // End class UserShellComponent
